<div class="modal-backdrop" (click)="onCancel()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Create New File</h3>
      <button class="close-btn" (click)="onCancel()" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <label for="file-name-input" class="input-label">File Name</label>
      <input 
        #fileInput
        id="file-name-input"
        type="text" 
        class="file-input"
        [(ngModel)]="fileName"
        (keydown)="onKeyPress($event)"
        placeholder="Enter file name..."
        maxlength="100"
        autofocus>
      <p class="help-text">Press Enter to create or Escape to cancel</p>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="onCancel()">
        Cancel
      </button>
      <button 
        class="btn btn-primary" 
        (click)="onCreate()"
        [disabled]="!fileName.trim()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
        Create File
      </button>
    </div>
  </div>
</div>
